const ACCOUNTS_CONSTANTS = {
  ACCOUNTS: 'Accounts',
};
export default ACCOUNTS_CONSTANTS;
